import React from 'react';
import { formatCurrency } from '../../../utils/formatNumber';
import { Status } from '../components/Status';
import { TRANSACTION_STATUS } from './types';

export const ORDERING_OPTIONS = [
  {
    id: 'name-asc',
    label: 'Nome (A - Z)',
    type: 'name',
    value: 'asc',
    isChecked: false,
  },
  {
    id: 'name-desc',
    label: 'Nome (Z - A)',
    type: 'name',
    value: 'desc',
    isChecked: false,
  },
  {
    id: 'price-asc',
    label: 'Preço do menor',
    type: 'price',
    value: 'asc',
    isChecked: false,
  },
  {
    id: 'price-desc',
    label: 'Preço do maior',
    type: 'price',
    value: 'desc',
    isChecked: false,
  },
  {
    id: 'older-asc',
    label: 'Mais antigos',
    type: 'createDate',
    value: 'asc',
    isChecked: false,
  },
  {
    id: 'newest-asc',
    label: 'Mais recentes',
    type: 'createDate',
    value: 'desc',
    isChecked: false,
  },
];

export const getFilterStatusOptions = () => {
  return [
    {
      value: TRANSACTION_STATUS.AWAITING_PAYMENT,
      label: 'Aguardando Pagamento',
    },
    {
      value: TRANSACTION_STATUS.PAID,
      label: 'Concluída',
    },
    {
      value: TRANSACTION_STATUS.AVAILABLE,
      label: 'Disponível',
    },
    {
      value: TRANSACTION_STATUS.ON_DISPUTE,
      label: 'Em disputa',
    },
    {
      value: TRANSACTION_STATUS.RETURNED,
      label: 'Devolvida',
    },
    {
      value: TRANSACTION_STATUS.CANCELED,
      label: 'Cancelada',
    },
    {
      value: TRANSACTION_STATUS.DEBITED,
      label: 'Debitado',
    },
    {
      value: TRANSACTION_STATUS.ON_HOLD,
      label: 'Retenção Temporária',
    },
  ];
};

export const generateTableColumns = ({
  numberOfRows,
  sortingDetails,
  onPrintAllRows,
  onPrintSelectedRows,
  onFinalizeOrder,
}: {
  numberOfRows?: number | string;
  sortingDetails?: object;
  onPrintAllRows?: () => void;
  onPrintSelectedRows?: (values: any | any[]) => void;
  onFinalizeOrder?: (id: string | number) => Promise<void>;
}) => [
  {
    type: 'checkbox',
    ref: 'id',
    actions: [
      {
        id: 1,
        title: 'Imprimir todos',
        label: `todos (${numberOfRows})`,
        icon: 'SvgIconPrint',
        request: onPrintAllRows,
      },
      {
        id: 2,
        title: 'Imprimir',
        icon: 'SvgIconPrint',
        request: onPrintSelectedRows,
      },
    ],
  },
  {
    title: 'Nº do pedido',
    ref: 'id',
    isTitle: true,
    width: '140px',
    columnClass: 'pv24',
    format: (data: any) => `#${data.id}`,
  },
  {
    title: 'Produto',
    ref: 'name',
    width: '170px',
    format: (data: any) => {
      const { name } = data;
      return <span className="truncate-m w4-m db-m">{name}</span>;
    },
  },
  {
    title: 'Quantidade',
    ref: 'amount',
    format: (data: any) => {
      const { amount } = data;
      return `${parseInt(amount, 10)} un.`;
    },
    columnClass: 'tl',
    width: '150px',
  },
  {
    title: 'Valor total',
    ref: 'price',
    columnClass: 'tl ph8',
    width: '150px',
    format: ({ price }: any) => formatCurrency(price),
  },
  {
    title: 'Status',
    ref: 'status',
    format: (data: any) => {
      const { id, status } = data;
      const onFinish = () => onFinalizeOrder && onFinalizeOrder(id);
      return <Status type={Number(status)} onFinish={onFinish} />;
    },
    columnClass: 'tl',
    width: '150px',
  },
  {
    type: 'actions',
    ref: 'actions',
    headerContent: sortingDetails,
    columnContent: [],
  },
];
